import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  input,
  InputSignal,
  signal,
  WritableSignal
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SzIconComponent } from '../../display/sz-icon';

@Component({
  selector: 'sz-search-input',
  templateUrl: './sz-search-input.component.html',
  styleUrls: ['./sz-search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SzSearchInputComponent),
      multi: true
    }
  ]
})
export class SzSearchInputComponent implements ControlValueAccessor {
  readonly placeholder: InputSignal<string> = input<string>('Search…');

  readonly value: WritableSignal<string> = signal<string>('');
  readonly disabledState: WritableSignal<boolean> = signal<boolean>(false);

  private onChange: (value: string) => void = (): void => {};
  private onTouched: () => void = (): void => {};

  writeValue(value: string | null): void {
    this.value.set(value ?? '');
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabledState.set(isDisabled);
  }

  onInput(event: Event): void {
    const target: HTMLInputElement = event.target as HTMLInputElement;
    this.value.set(target.value);
    this.onChange(target.value);
  }

  onBlur(): void {
    this.onTouched();
  }

  clear(): void {
    if (this.disabledState()) {
      return;
    }
    this.value.set('');
    this.onChange('');
  }
}
